module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Pride-And-Prejudice-landscape.ee3f3d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Pride-And-Prejudice-landscape.jpg
// module id = N872
// module chunks = 0